// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.selfupload.LeaseDocumentUploadWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseDocumentUploadWebApiHandler_deleteLeaseDocument,
  LeaseDocumentUploadWebApiHandler_getUploadedFileDetails,
  LeaseDocumentUploadWebApiHandler_getUploadedFileDetails_Path,
  LeaseDocumentUploadWebApiHandler_getZDocsUploadToken,
  LeaseDocumentUploadWebApiHandler_getZDocsUploadToken_Path,
  LeaseDocumentUploadWebApiHandler_renameLeaseDocuments,
  LeaseDocumentUploadWebApiHandler_reorderLeaseDocuments,
  LeaseDocumentUploadWebApiHandler_storeDocumentId,
  LeaseDocumentUploadWebApiHandler_submitDocumentChanges,
} from '@zg-rentals/ts-leasing-client';

import type {
  DeleteDocumentRequestDto,
  GetUploadedFileDetailsResponseDto,
  GetUploadTokenResponseDto,
  RenameLeaseDocumentsRequestDto,
  ReorderDocumentsRequestDto,
  StoreDocumentRequestDto,
  StoreDocumentResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface GetUploadedFileDetailsParams {
  leaseId: number;
}
interface GetZDocsUploadTokenParams {
  leaseId?: number;
  mergeWithMessageTokens?: boolean;
}
interface SubmitDocumentChangesParams {
  leaseId: number;
}

export interface LeaseDocumentUploadWebApiHandler_deleteLeaseDocument_Args {
  postData: DeleteDocumentRequestDto;
}

export type LeaseDocumentUploadWebApiHandler_deleteLeaseDocument_Options = UseMutationOptions<
  void,
  unknown,
  LeaseDocumentUploadWebApiHandler_deleteLeaseDocument_Args
>;

/**
 * delete uploaded document for lease
 */
export const useLeaseDocumentUploadWebApiHandler_deleteLeaseDocument = ({
  httpClient,
  ...options
}: Omit<LeaseDocumentUploadWebApiHandler_deleteLeaseDocument_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseDocumentUploadWebApiHandler_deleteLeaseDocument_Args) =>
      LeaseDocumentUploadWebApiHandler_deleteLeaseDocument(args.postData, httpClient),
  });
};

export type LeaseDocumentUploadWebApiHandler_getUploadedFileDetails_Options = UseQueryOptions<
  GetUploadedFileDetailsResponseDto,
  unknown,
  GetUploadedFileDetailsResponseDto,
  Array<string | GetUploadedFileDetailsParams>
>;

const LeaseDocumentUploadWebApiHandler_getUploadedFileDetails_GetKey = (getParams: GetUploadedFileDetailsParams) => [
  LeaseDocumentUploadWebApiHandler_getUploadedFileDetails_Path,
  getParams,
];

/**
 * get uploaded lease document file details
 */
export const useLeaseDocumentUploadWebApiHandler_getUploadedFileDetails = (
  getParams: GetUploadedFileDetailsParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseDocumentUploadWebApiHandler_getUploadedFileDetails_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseDocumentUploadWebApiHandler_getUploadedFileDetails_GetKey(getParams),
    queryFn: () => LeaseDocumentUploadWebApiHandler_getUploadedFileDetails(getParams, httpClient),
  });
};
useLeaseDocumentUploadWebApiHandler_getUploadedFileDetails.getKey =
  LeaseDocumentUploadWebApiHandler_getUploadedFileDetails_GetKey;

export type LeaseDocumentUploadWebApiHandler_getZDocsUploadToken_Options = UseQueryOptions<
  GetUploadTokenResponseDto,
  unknown,
  GetUploadTokenResponseDto,
  Array<string | GetZDocsUploadTokenParams>
>;

const LeaseDocumentUploadWebApiHandler_getZDocsUploadToken_GetKey = (getParams: GetZDocsUploadTokenParams) => [
  LeaseDocumentUploadWebApiHandler_getZDocsUploadToken_Path,
  getParams,
];

/**
 * get zdocs access token for upload
 */
export const useLeaseDocumentUploadWebApiHandler_getZDocsUploadToken = (
  getParams: GetZDocsUploadTokenParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseDocumentUploadWebApiHandler_getZDocsUploadToken_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseDocumentUploadWebApiHandler_getZDocsUploadToken_GetKey(getParams),
    queryFn: () => LeaseDocumentUploadWebApiHandler_getZDocsUploadToken(getParams, httpClient),
  });
};
useLeaseDocumentUploadWebApiHandler_getZDocsUploadToken.getKey =
  LeaseDocumentUploadWebApiHandler_getZDocsUploadToken_GetKey;

export interface LeaseDocumentUploadWebApiHandler_renameLeaseDocuments_Args {
  postData: RenameLeaseDocumentsRequestDto;
}

export type LeaseDocumentUploadWebApiHandler_renameLeaseDocuments_Options = UseMutationOptions<
  void,
  unknown,
  LeaseDocumentUploadWebApiHandler_renameLeaseDocuments_Args
>;

/**
 * rename lease document
 */
export const useLeaseDocumentUploadWebApiHandler_renameLeaseDocuments = ({
  httpClient,
  ...options
}: Omit<LeaseDocumentUploadWebApiHandler_renameLeaseDocuments_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseDocumentUploadWebApiHandler_renameLeaseDocuments_Args) =>
      LeaseDocumentUploadWebApiHandler_renameLeaseDocuments(args.postData, httpClient),
  });
};

export interface LeaseDocumentUploadWebApiHandler_reorderLeaseDocuments_Args {
  postData: ReorderDocumentsRequestDto;
}

export type LeaseDocumentUploadWebApiHandler_reorderLeaseDocuments_Options = UseMutationOptions<
  void,
  unknown,
  LeaseDocumentUploadWebApiHandler_reorderLeaseDocuments_Args
>;

/**
 * reorder lease documents
 */
export const useLeaseDocumentUploadWebApiHandler_reorderLeaseDocuments = ({
  httpClient,
  ...options
}: Omit<LeaseDocumentUploadWebApiHandler_reorderLeaseDocuments_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseDocumentUploadWebApiHandler_reorderLeaseDocuments_Args) =>
      LeaseDocumentUploadWebApiHandler_reorderLeaseDocuments(args.postData, httpClient),
  });
};

export interface LeaseDocumentUploadWebApiHandler_storeDocumentId_Args {
  postData: StoreDocumentRequestDto;
}

export type LeaseDocumentUploadWebApiHandler_storeDocumentId_Options = UseMutationOptions<
  StoreDocumentResponseDto,
  unknown,
  LeaseDocumentUploadWebApiHandler_storeDocumentId_Args
>;

/**
 * store zdocs document id
 */
export const useLeaseDocumentUploadWebApiHandler_storeDocumentId = ({
  httpClient,
  ...options
}: Omit<LeaseDocumentUploadWebApiHandler_storeDocumentId_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseDocumentUploadWebApiHandler_storeDocumentId_Args) =>
      LeaseDocumentUploadWebApiHandler_storeDocumentId(args.postData, httpClient),
  });
};

export interface LeaseDocumentUploadWebApiHandler_submitDocumentChanges_Args {
  getParams: SubmitDocumentChangesParams;
}

export type LeaseDocumentUploadWebApiHandler_submitDocumentChanges_Options = UseMutationOptions<
  void,
  unknown,
  LeaseDocumentUploadWebApiHandler_submitDocumentChanges_Args
>;

/**
 * submit document fields changes
 */
export const useLeaseDocumentUploadWebApiHandler_submitDocumentChanges = ({
  httpClient,
  ...options
}: Omit<LeaseDocumentUploadWebApiHandler_submitDocumentChanges_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeaseDocumentUploadWebApiHandler_submitDocumentChanges_Args) =>
      LeaseDocumentUploadWebApiHandler_submitDocumentChanges(args.getParams, httpClient),
  });
};
